module.exports = __webpack_public_path__ + "img/version_star.0a13b24a.png";